import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { Modal } from 'react-bootstrap';
import * as yup from 'yup';
import { T } from '../../../components/basic/text';
import { FormikTextField } from '../../../components/formik/formik-text-field';
import { SysMenuGroup } from './sys-menu-types';

type SysMenuGroupsModalProps = {
    current: SysMenuGroup;
    show: boolean;
    onHide: () => void;
    onSave: (values: any, onHide: () => void) => void;
};

export const SysMenuGroupsModal = ({ current, show, onHide, onSave }: SysMenuGroupsModalProps) => {
    const insertMode = !current.id;

    const onSubmit = (values: any) => {
        onSave(values, onHide);
    };

    return (
        <>
            <Modal show={show} onHide={onHide} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <Modal.Title>
                            {insertMode && <T>add</T>}
                            {!insertMode && <T>edit</T>}
                        </Modal.Title>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Formik
                        initialValues={current}
                        validationSchema={yup.object({
                            id: yup.string().nullable().required(' '),
                            title: yup.string().nullable().required(' '),
                            sortOrder: yup.string().nullable().required(' '),
                        })}
                        onSubmit={onSubmit}
                    >
                        {formik => (
                            <Form>
                                <FormikTextField
                                    name="id"
                                    inputStyle={{ width: '10rem' }}
                                    label={<T>id</T>}
                                    labelWidth={2}
                                    readOnly={!insertMode}
                                    maxLength={50}
                                />

                                <FormikTextField
                                    name="title"
                                    inputStyle={{ width: '15rem' }}
                                    label={<T>title</T>}
                                    labelWidth={2}
                                    maxLength={100}
                                    postfixLabel={
                                        <T className="m-s-2 px-1 bg-gray-5 rounded-pill small">
                                            {formik.values.title}
                                        </T>
                                    }
                                />

                                <FormikTextField
                                    name="templateCode"
                                    inputStyle={{ width: '10rem' }}
                                    label={<T>template-code</T>}
                                    labelWidth={2}
                                    maxLength={100}
                                />

                                <FormikTextField
                                    name="subTitle"
                                    inputStyle={{ width: '10rem' }}
                                    label={<T>sub-title</T>}
                                    labelWidth={2}
                                    maxLength={100}
                                />

                                <FormikTextField
                                    name="sortOrder"
                                    inputStyle={{ width: '20rem' }}
                                    label={<T>sort-order</T>}
                                    labelWidth={2}
                                    maxLength={100}
                                />

                                <FormikTextField
                                    name="iconCss"
                                    inputStyle={{ width: '20rem' }}
                                    label={<T>icon-css</T>}
                                    labelWidth={2}
                                    maxLength={100}
                                />

                                <FormikTextField
                                    name="iconCode"
                                    inputStyle={{ width: '20rem' }}
                                    label={<T>icon-code</T>}
                                    labelWidth={2}
                                    maxLength={100}
                                />

                                <bd.FormRow labelWidth={2} className="py-1 m-e-0">
                                    <bd.Button
                                        type="submit"
                                        variant="contained"
                                        className="m-s-auto m-e-2"
                                        disabled={!formik.isValid}
                                    >
                                        <T>save-changes</T>
                                    </bd.Button>

                                    <bd.Button
                                        variant="outline"
                                        className="min-w-80"
                                        type="button"
                                        onClick={onHide}
                                    >
                                        <T>cancel</T>
                                    </bd.Button>
                                </bd.FormRow>
                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal>
        </>
    );
};
